import { queryOptions } from '@tanstack/react-query';

import { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

export type SearchUsersV2Data = NonNullable<
  paths['/v2/users']['get']['responses'][200]['content']['application/json']['data']
>;

export type SearchUsersV2User = SearchUsersV2Data['users'][number];

export type SearchUsersV2Query = NonNullable<paths['/v2/users']['get']['parameters']['query']>;

export async function searchUsersV2({
  q = '',
  userType,
  role,
  page = 1,
  limit = 25,
}: SearchUsersV2Query): Promise<SearchUsersV2Data | undefined> {
  const query: SearchUsersV2Query = { page, limit };

  if (q && q.trim().length > 0) {
    query.q = q;
  }

  if (userType) {
    query.userType = userType;
  }

  if (role) {
    query.role = role;
  }

  const { data } = await fetchClient.GET('/v2/users', {
    params: { query },
  });

  return data?.data;
}

export function getSearchUsersV2QueryOptions({
  q = '',
  userType,
  role,
  page = 1,
  limit = 25,
}: SearchUsersV2Query) {
  return queryOptions<SearchUsersV2Data | undefined>({
    queryKey: ['searchUsersV2', { q, userType, role, page, limit }],
    queryFn: () => searchUsersV2({ q, userType, role, page, limit }),
    enabled: q.trim().length > 0 || userType != null || role != null,
  });
}
